import React, { useEffect, useState } from 'react'
import { FixBtns, LectureView, LectureViewHeader, LectureViewTable, LectureWrapper } from '../Lecture/styles'
import AcademyList from './AcademyList'
import AcademyTotalTable from './AcademyTotalTable'
import AddAcademyModal from 'app/gomsacademy/components/AddAcademyModal'
import { useAcademyList } from 'app/gomsacademy/hooks/AcademyList'
import { useGetMyInfo } from 'app/gomsacademy/hooks/GetMyInfo'
import { usePaySSAMMerchant } from 'app/gomsacademy/hooks/PaySSAMMerchant'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { message, Upload } from 'antd'
import { STORAGE_URL } from 'app/constants/APIKEYS'
import styled from 'styled-components'


export const Academy = () => {
  const { data: token } = useToken()
  const { AcademyListData, mutate: academyMutate } = useAcademyList()
  const { myInfo } = useGetMyInfo()

  const [isAddAcademy, setIsAddAcademy] = useState(false)
  const [selectAcademy, setSelectAcademy] = useState('')
  const [isTotal, setIsTotal] = useState(true)
  const [isFix, setIsFix] = useState(false)
  const academy = AcademyListData.filter(it => it.id == selectAcademy)
  const [editPassword, setEditPassword] = useState(false)
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [uploading, setUploading] = useState(false)

  const [fixName, setFixName] = useState(academy[0]?.name || '')
  const [fixDirector, setFixDirector] = useState(academy[0]?.representativeName || '')
  const [fixTel, setFixTel] = useState(academy[0]?.tel || '')
  const [fixDesc, setFixDesc] = useState(academy[0]?.desc || '')
  const [fixAddress, setFixAddress] = useState(academy[0]?.address || '')
  const [fixCreatedAt, setFixCreatedAt] = useState(academy[0]?.createdAt || '')

  // PaySSAM Merchant Management
  const [showMerchantPanel, setShowMerchantPanel] = useState(false)
  const selectedDeptId = selectAcademy ? parseInt(selectAcademy) : undefined
  const {
    merchantStatus,
    merchantInfo,
    loadingStatus: loadingMerchantStatus,
    loadingInfo: loadingMerchantInfo,
    registering: registeringMerchant,
    registerMerchant,
    refreshStatus,
    getMerchantInfo,
  } = usePaySSAMMerchant(selectedDeptId)

  const DeleteAcademy = (branchId, academyName) => {
    const shouldDelete = window.confirm(`정말로 '${academyName}' 지점을 삭제하시겠습니까?`)

    if (shouldDelete) {
      API.delete('/branch/' + branchId, token + '', {})
        .then((res: any) => {
          if (res.result.success) {
            message.success('삭제되었습니다')
            academyMutate()
            setIsTotal(true)
          } else {

            if (res?.result?.message?.includes('foreign key')) {
              message.error('연결된 데이터가 있어 삭제할 수 없습니다.')
            } else {
              message.error(res?.result?.message || '삭제에 실패했습니다.')
            }
          }
        })
        .catch((err: any) => {})
    }
  }
  const SaveAcademy = (branchId) => {
    API.put('/branch/' + branchId, token + '', {
      datas: {
        name: fixName,
        representativeName: fixDirector,
        tel: fixTel,
        desc: fixDesc,
        address: fixAddress,
        createdAt: fixCreatedAt,
      }
      })
      .then((res: any) => {
        if (res.result.success) {
          message.success('수정되었습니다')
          academyMutate()
          setIsFix(false)
        }
      })
      .catch((err: any) => {})
  }

  const savePassword = (userId) => {
    API.put('/users/' + userId, token + '', {
      password: newPassword,
    })
      .then((res: any) => {
        if (res.result.success) {
          message.success('비밀번호가 변경되었습니다.')
          academyMutate()
          setEditPassword(false)
        }
      })
      .catch((err: any) => {})
  }

  const handleLogoUpload = async (file: File) => {
    // Client-side validation
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('JPG/PNG 파일만 업로드 가능합니다.')
      return false
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error('이미지는 10MB 이하여야 합니다.')
      return false
    }

    const formData = new FormData()
    formData.append('file', file)

    setUploading(true)
    try {
      const res = await API.postImage('POST', `/branch/${academy[0]?.id}/logo`, token + '', formData)
      if (res.result.success) {
        message.success('로고가 업로드되었습니다.')
        academyMutate()
      } else {
        message.error(res.result.message || '로고 업로드에 실패했습니다.')
      }
    } catch (err) {
      message.error('로고 업로드 중 오류가 발생했습니다.')
    } finally {
      setUploading(false)
    }
    return false // Prevent default upload
  }

  const handleLogoDelete = async () => {
    const shouldDelete = window.confirm('정말로 로고를 삭제하시겠습니까?')
    if (!shouldDelete) return

    try {
      const res = await API.delete(`/branch/${academy[0]?.id}/logo`, token + '', {})
      if (res.result.success) {
        message.success('로고가 삭제되었습니다.')
        academyMutate()
      } else {
        message.error(res.result.message || '로고 삭제에 실패했습니다.')
      }
    } catch (err) {
      message.error('로고 삭제 중 오류가 발생했습니다.')
    }
  }

  const handleClickOutsideSelect = (event) => {
    if (!event.target.closest('.selectAcademy')) {
      setIsFix(false)
    }
    if (!event.target.closest('.editPassword')) {
      setEditPassword(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideSelect)
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideSelect)
    }
  }, [])

  // PaySSAM Merchant Management Handlers
  const handleRegisterMerchant = async () => {
    try {
      await registerMerchant()
    } catch (err) {
      // Error already handled in hook
    }
  };

  const handleRefreshMerchantStatus = async () => {
    try {
      await refreshStatus(true)
    } catch (err) {
      // Error already handled in hook
    }
  };

  const handleGetMerchantInfo = async () => {
    try {
      await getMerchantInfo()
    } catch (err) {
      // Error already handled in hook
    }
  };

  // Load merchant status when dept is selected (silent, no message)
  useEffect(() => {
    if (selectAcademy && myInfo?.admin) {
      refreshStatus(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAcademy])

  return (
    <LectureWrapper>
      <AcademyList
        setIsAddAcademy={setIsAddAcademy}
        selectAcademy={selectAcademy}
        setSelectAcademy={setSelectAcademy}
        setIsTotal={setIsTotal}
      />
      <LectureView>
        {isTotal && (
          <AcademyTotalTable setSelectAcademy={setSelectAcademy} setIsTotal={setIsTotal} />
        )}
        {isTotal == false && selectAcademy && (
          <div className='selectAcademy'>
            <LectureViewHeader>
              <p>{academy[0]?.name}</p>
              <FixBtns>
                {!isFix ? (
                  <>
                    <button className='fix' onClick={() => setIsFix(true)}>수정</button>
                    <button className='delete' onClick={() => DeleteAcademy(academy[0]?.id, academy[0]?.name)}>삭제</button>
                  </>
                ) : (
                  <>
                    <button className='fix' onClick={() => SaveAcademy(academy[0]?.id)}>저장</button>
                    <button className='delete' onClick={() => setIsFix(false)}>취소</button>
                  </>
                )}
              </FixBtns>
            </LectureViewHeader>
            
            {/* Logo Section */}
            <LogoSection>
              <LogoLabel>학원 로고</LogoLabel>
              <LogoContent>
                {academy[0]?.logoUrl ? (
                  <LogoPreview>
                    <img 
                      src={`${STORAGE_URL}/${academy[0].logoUrl}`} 
                      alt="학원 로고"
                      style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }}
                    />
                  </LogoPreview>
                ) : (
                  <LogoPlaceholder>로고 없음</LogoPlaceholder>
                )}
                {isFix && (
                  <LogoButtons>
                    <Upload
                      accept="image/jpeg,image/png"
                      beforeUpload={handleLogoUpload}
                      showUploadList={false}
                    >
                      <button 
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#1890ff',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                        disabled={uploading}
                      >
                        {uploading ? '업로드 중...' : academy[0]?.logoUrl ? '로고 교체' : '로고 업로드'}
                      </button>
                    </Upload>
                    {academy[0]?.logoUrl && (
                      <button
                        onClick={handleLogoDelete}
                        style={{
                          padding: '8px 16px',
                          backgroundColor: '#ff4d4f',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          marginLeft: '8px'
                        }}
                      >
                        로고 삭제
                      </button>
                    )}
                  </LogoButtons>
                )}
              </LogoContent>
            </LogoSection>

            <LectureViewTable>
              <thead>
                <tr>
                  <th>학원명</th>
                  <th>대표원장</th>
                  <th style={{ minWidth: '60px' }}>아이디</th>
                  <th>비밀번호</th>
                  <th>전화번호</th>
                  <th>주소</th>
                  <th>등록일</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {!isFix ? (
                      academy[0]?.name
                    ) : (
                      <input type='text' placeholder={`${academy[0]?.name}`} onChange={(e) => setFixName(e.target.value)} />
                    )}
                  </td>
                  <td>
                    {!isFix ? (
                      academy[0]?.representativeName
                    ) : (
                      <input type='text' placeholder={`${academy[0]?.representativeName}`} onChange={(e) => setFixDirector(e.target.value)} />
                    )}
                  </td>
                  <td>
                    {academy[0]?.email}
                  </td>
                  <td className='editPassword'>
                    {!editPassword ? (
                      <button
                        style={{
                          minWidth: '95px',
                          border: '1px solid #676767',
                          backgroundColor: '#222222',
                          color: '#fff',
                          borderRadius: '4px',
                          padding: '5px 5px'
                        }}
                        onClick={() => setEditPassword(true)}
                      >
                        비밀번호 변경
                      </button>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <input type='password' placeholder='새 비밀번호 입력' autoFocus onChange={(e) => setPassword(e.target.value)} />
                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                          <button
                            style={{ borderRadius: '4px', backgroundColor: '#666', color: '#Fff' }}
                            onClick={() => setEditPassword(false)}
                          >
                            취소
                          </button>
                          <button
                            style={{ borderRadius: '4px', backgroundColor: '#F78B85', color: '#Fff', border: '1px solid #F78B85' }}
                            onClick={() => savePassword(academy[0]?.id)}
                          >
                            변경
                          </button>
                        </div>
                      </div>
                    )}
                  </td>
                  <td>
                    {!isFix ? (
                      academy[0]?.tel
                    ) : (
                      <input type='text' placeholder={`${academy[0]?.tel}`} onChange={(e) => setFixTel(e.target.value)} />
                    )}
                  </td>
                  <td>
                    {!isFix ? (
                      academy[0]?.address
                    ) : (
                      <input type='text' placeholder={`${academy[0]?.address}`} onChange={(e) => setFixAddress(e.target.value)} />
                    )}
                  </td>
                  <td>
                    {!isFix ? (
                      academy[0]?.createdAt
                    ) : (
                      <input type='date' onChange={(e) => setFixCreatedAt(e.target.value)} />
                    )}
                  </td>
                  <td className='person'>
                    {!isFix ? (
                      academy[0]?.desc
                    ) : (
                      <input type='text' placeholder={`${academy[0]?.desc}`} onChange={(e) => setFixDesc(e.target.value)} />
                    )}
                  </td>
                </tr>
              </tbody>
            </LectureViewTable>

            {/* PaySSAM Merchant Management Panel (Admin Only) */}
            {myInfo?.admin && (
              <MerchantManagementSection>
                <MerchantSectionHeader>
                  <h3>결제계정 관리 (결제선생)</h3>
                  <button
                    onClick={() => setShowMerchantPanel(!showMerchantPanel)}
                    style={{
                      padding: '6px 12px',
                      backgroundColor: showMerchantPanel ? '#f0f0f0' : '#1890ff',
                      color: showMerchantPanel ? '#333' : '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    {showMerchantPanel ? '접기' : '펼치기'}
                  </button>
                </MerchantSectionHeader>

                {showMerchantPanel && (
                  <MerchantPanelContent>
                    <MerchantStatusCard>
                      <StatusRow>
                        <StatusLabel>연동 상태:</StatusLabel>
                        <StatusValue>
                          {merchantStatus?.openCode === '0000' ? (
                            <StatusBadge color="#52c41a">개시됨 (결제 가능)</StatusBadge>
                          ) : merchantStatus?.openCode === '1010' ? (
                            <StatusBadge color="#faad14">미연동 (가입 필요)</StatusBadge>
                          ) : merchantStatus?.openCode === '1700' ? (
                            <StatusBadge color="#ff4d4f">오류</StatusBadge>
                          ) : merchantStatus?.reviewStatus ? (
                            <StatusBadge color="#1890ff">
                              {merchantStatus.reviewStatus === 'W' ? '심사중' :
                               merchantStatus.reviewStatus === 'P' ? '보완' :
                               merchantStatus.reviewStatus === 'R' ? '반려' :
                               merchantStatus.reviewStatus === 'S' ? '승인' :
                               merchantStatus.reviewStatus === 'O' ? '개시' :
                               merchantStatus.reviewStatus === 'N' ? '미등록' : merchantStatus.reviewStatus}
                            </StatusBadge>
                          ) : (
                            <StatusBadge color="#999999">미연동</StatusBadge>
                          )}
                        </StatusValue>
                      </StatusRow>

                      {merchantStatus?.memberId && (
                        <StatusRow>
                          <StatusLabel>가맹점 사용자 코드:</StatusLabel>
                          <StatusValue>{merchantStatus.memberId}</StatusValue>
                        </StatusRow>
                      )}

                      {merchantStatus?.merchantId && (
                        <StatusRow>
                          <StatusLabel>가맹점 매장 코드:</StatusLabel>
                          <StatusValue>{merchantStatus.merchantId}</StatusValue>
                        </StatusRow>
                      )}

                      {merchantStatus?.openCode && (
                        <StatusRow>
                          <StatusLabel>개시 상태 코드:</StatusLabel>
                          <StatusValue>{merchantStatus.openCode}</StatusValue>
                        </StatusRow>
                      )}

                      <MerchantActions>
                        <MerchantButton
                          onClick={handleRegisterMerchant}
                          disabled={registeringMerchant}
                          $primary
                        >
                          {registeringMerchant ? '처리 중...' : '연동 시작'}
                        </MerchantButton>
                        <MerchantButton
                          onClick={handleRefreshMerchantStatus}
                          disabled={loadingMerchantStatus}
                        >
                          {loadingMerchantStatus ? '조회 중...' : '상태 새로고침'}
                        </MerchantButton>
                        <MerchantButton
                          onClick={handleGetMerchantInfo}
                          disabled={loadingMerchantInfo}
                        >
                          {loadingMerchantInfo ? '조회 중...' : '가맹점 정보 보기'}
                        </MerchantButton>
                      </MerchantActions>

                      {merchantInfo && (
                        <MerchantInfoCard>
                          <InfoTitle>가맹점 정보</InfoTitle>
                          <pre style={{ fontSize: '12px', overflow: 'auto', maxHeight: '200px' }}>
                            {JSON.stringify(merchantInfo, null, 2)}
                          </pre>
                        </MerchantInfoCard>
                      )}
                    </MerchantStatusCard>
                  </MerchantPanelContent>
                )}
              </MerchantManagementSection>
            )}
          </div>
        )}
      </LectureView>
      {isAddAcademy && <AddAcademyModal setIsAddAcademy={setIsAddAcademy} />}
    </LectureWrapper>
  )
}

const LogoSection = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
`;

const LogoLabel = styled.div`
  font-weight: bold;
  min-width: 100px;
  padding-top: 8px;
`;

const LogoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LogoPreview = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 12px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoPlaceholder = styled.div`
  width: 200px;
  height: 200px;
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #fafafa;
`;

const LogoButtons = styled.div`
  display: flex;
  align-items: center;
`;

const MerchantManagementSection = styled.div`
  margin-top: 30px;
  padding: 20px;
  border-top: 2px solid #e8e8e8;
  background-color: #fafafa;
`;

const MerchantSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
`;

const MerchantPanelContent = styled.div`
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
`;

const MerchantStatusCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StatusLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #666;
  min-width: 150px;
`;

const StatusValue = styled.span`
  font-size: 14px;
  color: #333;
`;

const StatusBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: ${props => props.color}20;
  color: ${props => props.color};
  font-size: 13px;
  font-weight: 500;
`;

const MerchantActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

const MerchantButton = styled.button<{ $primary?: boolean }>`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${props => (props.$primary ? '#1890ff' : '#d9d9d9')};
  background-color: ${props => (props.$primary ? '#1890ff' : '#fff')};
  color: ${props => (props.$primary ? '#fff' : '#333')};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${props => (props.$primary ? '#40a9ff' : '#f5f5f5')};
    border-color: ${props => (props.$primary ? '#40a9ff' : '#40a9ff')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const MerchantInfoCard = styled.div`
  margin-top: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
`;

const InfoTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
`;

export default React.memo(Academy);